import { useState } from "react";
import { Section, SectionHeading } from "@/components/common/Section";
import { portfolio, portfolioCategories } from "@/data/content";

export function Portfolio() {
  const [active, setActive] = useState("All");
  const items = active === "All" ? portfolio : portfolio.filter((p) => p.category === active);

  return (
    <Section id="portfolio" bg="mist">
      <SectionHeading
        eyebrow="Our Work"
        title="A portfolio built on premium finish"
        subtitle="Explore a selection of office branding, signage and installation projects. Swap in your own project photos anytime."
        align="center"
      />

      {/* Filter tabs */}
      <div className="mt-10 flex flex-wrap justify-center gap-2" data-testid="portfolio-filters">
        {portfolioCategories.map((cat) => (
          <button
            key={cat}
            onClick={() => setActive(cat)}
            data-testid={`portfolio-filter-${cat.replace(/\s+|&/g, "-").toLowerCase()}`}
            className={`px-4 py-2 text-sm font-medium transition-colors duration-200 ${
              active === cat
                ? "bg-navy text-white"
                : "bg-white text-charcoal border border-black/5 hover:border-gold/60 hover:text-gold-dark"
            }`}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* Gallery */}
      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.map((item) => (
          <figure
            key={item.title}
            data-testid={`portfolio-item-${item.title.replace(/\s+/g, "-").toLowerCase()}`}
            className="group relative overflow-hidden bg-navy"
          >
            <img
              src={item.img}
              alt={`${item.title} — ${item.category} project by BNZ Solutions, Bengaluru`}
              loading="lazy"
              className="aspect-[4/3] w-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-navy-dark/90 via-navy/20 to-transparent opacity-80 transition-opacity duration-300" />
            <figcaption className="absolute bottom-0 left-0 right-0 p-5 translate-y-1 transition-transform duration-300 group-hover:translate-y-0">
              <span className="text-xs uppercase tracking-[0.2em] text-gold-light">{item.category}</span>
              <h3 className="mt-1 font-heading text-lg text-white">{item.title}</h3>
            </figcaption>
          </figure>
        ))}
      </div>
    </Section>
  );
}
